import { Component, Input, OnInit, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { IConfigVecino } from 'modelos/src';

@Component({
  selector: 'app-config-vecino',
  templateUrl: './config-vecino.component.html',
  styleUrls: ['./config-vecino.component.scss'],
  standalone: false,
})
export class ConfigVecinoComponent implements OnInit {
  private snackBar = inject(MatSnackBar);

  @Input() config?: IConfigVecino;

  public copiar(texto: string) {
    navigator.clipboard.writeText(texto);
    this.snackBar.open('Dirección copiada al portapapeles', 'Cerrar', {
      duration: 2000,
    });
  }

  ngOnInit(): void {}
}
